import { useCallback } from "react";
import { useMutation } from "react-query";

import { MUTATION_KEYS } from "../../../constants/queryKeys";
import { CasProfileApi } from "../../../services";

import type { UseCheckPhoneReturnType } from "./types";

export const useCheckPhone = (): UseCheckPhoneReturnType => {
  const callCheckPhone = useMutation(MUTATION_KEYS.checkPhone, (phone: string) =>
    CasProfileApi.init().verifiedPhone(phone)
  );

  const checkPhone = useCallback(async (phone: string) => await callCheckPhone.mutateAsync(phone), [callCheckPhone]);

  return { checkPhone };
};
